/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable react/no-deprecated */
import React from 'react';
import { Row, Col } from '@vds/grids';
import PropTypes from 'prop-types';

import Button from '../../../../common/Button/index';
import CheckBox from '../../../../common/CheckBox';
import {
  isPreorder,
  viewport,
  getAPPID,
  isMobile,
  isTablet,
  isDesktopResolution,
  setSession,
  isACPEligibile,
  isVFEligibile,
} from '../../../../common/Helpers/index';
import * as validation from '../../../../common/validation.js';
import { goToProcessStep } from '../../../../../redirection';
import CreditCheckForm from './creditCheckForm';
import EidQuestionnaire from './EidQuestionnaire';
import NortonSeal from '../../../../../assets/images/norton_secure_seal.svg';
import PersonalInfoContext from '../personalnfoContext';
import { store } from '../../../../../configureStore';
import { Body } from '../../../../common/Typography/index';
import { StyledVdsRow } from '../../../../common/styles';
import { hideLoader } from '../../../../common/Helpers/loader';
import { eventDispatcher } from '../../../../common/Tagging/index.js';

export default class personalInformation extends React.PureComponent {
  constructor(props) {
    super(props);
    let dateString = '';
    if ((isACPEligibile() || isVFEligibile()) && this.props?.cartDetails?.primaryUserInfo?.dob) {
      const date = new Date(this.props?.cartDetails?.primaryUserInfo?.dob);
      dateString = [
        (date?.getMonth() + 1)?.toString()?.length === 1 ? `0${date?.getMonth() + 1}` : date?.getMonth() + 1,
        date?.getDate()?.toString()?.length === 1 ? `0${date?.getDate()}` : date?.getDate(),
        date?.getFullYear(),
      ].join('/');
    }
    this.state = {
      enableCheckbox: false,
      fName: '',
      lName: '',
      addressLine1: '',
      addressLine2: '',
      zipCode: '',
      city: '',
      state: '',
      phoneNumber: '',
      dob: dateString,
      ssn: '',
      isEidDataPosted: false,
      eidTagging: false,
      selectedAddress: false,
      acpSSNCheckValue: false,
      vfSSNCheckValue: false,
    };
  }

  componentDidMount() {
    const { updatePersonalInfoListerner } = this.context;
    if (updatePersonalInfoListerner) {
      updatePersonalInfoListerner(this.onClickRunCreditCheck);
    }
    const isLoggedIn = getAPPID() === 'AAL';
    if (!(isPreorder() && isLoggedIn !== true)) {
      store.dispatch({ type: 'UPDATE_API_STATUS', response: 'IN_PROGRESS' });
      if (isMobile() && window.vzFlags?.miniCartApi) {
        this.props.getMiniCartAPI();
      } else {
        this.props.getCartDataFromApi('creditcheck');
      }
    }

    let dateString = '';
    if ((isVFEligibile() || isACPEligibile()) && this.props?.cartDetails?.primaryUserInfo?.dob) {
      const date = new Date(this.props?.cartDetails?.primaryUserInfo?.dob);
      dateString = [
        (date?.getMonth() + 1)?.toString()?.length === 1 ? `0${date?.getMonth() + 1}` : date?.getMonth() + 1,
        date?.getDate()?.toString()?.length === 1 ? `0${date?.getDate()}` : date?.getDate(),
        date?.getFullYear(),
      ].join('/');
    }

    if (this.state.dob === '' && dateString !== '') {
      this.setState({ dob: dateString });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps?.retrieveCartAPIStatus === 'COMPLETED' && this.props.retrieveCartAPIStatus === 'IN_PROGRESS') {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        fName:
          nextProps.contactDetails && nextProps.contactDetails.firstName
            ? nextProps.contactDetails.firstName
            : nextProps.contactDetails?.address?.firstName,
        lName:
          nextProps.contactDetails && nextProps.contactDetails.lastName
            ? nextProps.contactDetails.lastName
            : nextProps.contactDetails?.address?.lastName,
        addressLine1: nextProps?.contactDetails?.address?.addressLine1,
        addressLine2: nextProps?.contactDetails?.address?.addressLine2,
        city: nextProps?.contactDetails?.address?.city,
        state: nextProps?.contactDetails?.address?.state,
        zipCode: nextProps?.contactDetails?.address?.zipCode,
        phoneNumber: nextProps?.contactDetails?.address?.phoneNumber,
      });
      hideLoader();
    }
  }

  componentDidUpdate(prevState) {
    if (prevState.dob !== this.state.dob) {
      let value = this.state.dob;
      if (value?.match(/^\d{2}$/) !== null) {
        value += '/';
      } else if (value?.match(/^\d{2}\/\d{2}$/) !== null) {
        value += '/';
      }
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ dob: value });
    }
    const currentCTAStatus = this.shouldEnableCTA(this.state);
    const lastCTAStatus = this.shouldEnableCTA(prevState);
    const { updatePersonalInfoCTA } = this.context;
    if (currentCTAStatus !== lastCTAStatus) {
      updatePersonalInfoCTA(currentCTAStatus);
    }
    if (prevState.ssn !== this.state.ssn && isACPEligibile()) {
      if (this.state?.acpSSNCheckValue === false && this.state?.showSsnError === false) {
        eventDispatcher('sendData', {
          name: '',
          svars: {
            evar13: 'ssn does not match with acp eligibility verification',
            evar22: 'message displayed',
          },
        });
      }
    }
    if (prevState.ssn !== this.state.ssn && isVFEligibile()) {
      if (this.state?.vfSSNCheckValue === false && this.state?.showSsnError === false) {
        eventDispatcher('sendData', {
          name: '',
          svars: {
            evar13: 'ssn does not match with vf eligibility verification',
            evar22: 'message displayed',
          },
        });
      }
    }
  }

  shouldEnableCTA = (state = {}) => {
    const enableButton = !state.showDobError && !state.showSsnError;
    const fieldvalueChecking =
      state.dob !== '' &&
      state.ssn !== '' &&
      state.enableCheckbox &&
      (isVFEligibile() ? state.vfSSNCheckValue : isACPEligibile() ? state.acpSSNCheckValue : true);
    return !(!enableButton ? true : !fieldvalueChecking);
  };

  onChangeTextBox = (name, e) => {
    let { value } = e.target;
    let showDobError = !this.state.showDobError;
    let showSsnError = !this.state.showSsnError;
    if (name === 'dob') {
      if (value) {
        const x = value;
        const str = x.replace(/\//g, '').toString();
        const DateFormat = `${str.slice(0, 2)}/${str.slice(2, 4)}/${str.slice(4, 8)}`;
        value = DateFormat;
        showDobError = validation.isValidDOB(DateFormat);
      }
    } else if (name === 'ssn') {
      showSsnError = validation.isValidSSN(value);
      if (isACPEligibile() && showSsnError) {
        this.acpSSNCheck(value, this.props?.cartDetails?.primaryUserInfo?.ssn);
      }
      if (isVFEligibile() && showSsnError) {
        this.vfSSNCheck(value, this.props?.cartDetails?.primaryUserInfo?.ssn);
      }
    }
    this.setState({
      [name]: value,
      showDobError: showDobError !== undefined && !showDobError,
      showSsnError: showSsnError !== undefined && !showSsnError,
    });
  };

  acpSSNCheck = (existingValue, enteredValue) => {
    const regexPattern = /(\d{4})$/gi;
    const ssnMatchCheck = existingValue?.match(regexPattern)?.[0] === enteredValue;
    this.setState({ acpSSNCheckValue: ssnMatchCheck });
  };

  vfSSNCheck = (existingValue, enteredValue) => {
    const regex = /(\d{4})$/g;
    const match1 = existingValue.match(regex);
    const match2 = enteredValue.match(regex);
    if (match1 && match2 && match1[0] === match2[0]) {
      this.setState({ vfSSNCheckValue: true });
    } else {
      this.setState({ vfSSNCheckValue: false });
    }
  };

  onClickRunCreditCheck = () => {
    const states = this.state;
    this.props.getCreditCheckOnClick(states);
  };

  onEidQuestiosAnswerSubmit = (e, answers) => {
    e.preventDefault();
    this.props.postEidQuestionsAnswers(answers);
    this.setState({
      ...this.state,
      isEidDataPosted: true,
    });
  };

  setAgreementStatus = (value) => {
    try {
      this.context.setAgreementStatus(value);
    } catch (error) {
      // Context Unavailable
    }
  };

  checkboxStatus = (e) => {
    e.preventDefault();
    if (e.keyCode === 32 || e.keyCode === 13) {
      this.setState((prevState) => ({
        enableCheckbox: !prevState.enableCheckbox,
      }));
      this.setAgreementStatus(!this.state.enableCheckbox);
    } else {
      this.setState({
        enableCheckbox: e.target.checked,
      });
      this.setAgreementStatus(e.target.checked);
    }
  };

  eidTagging = (type) => {
    if (type) {
      setSession('showEid', true);
      if (!this.state.eidTagging) {
        this.props.invokeTaggingAPI();
        this.setState({
          eidTagging: true,
        });
      }
    } else {
      setSession('showEid', false);
    }
  };

  onAddressSelection = (e) => {
    const addressSelected = this.props.addressList.filter((item) => item.disprawstr === e);
    const billingDetails = {
      addressLine1: addressSelected?.[0]?.dispstr,
      zipCode: addressSelected?.[0]?.zip,
      state: addressSelected?.[0]?.state,
      city: addressSelected?.[0]?.muni,
    };
    this.setState({ ...billingDetails, selectedAddress: true });
  };

  static contextType = PersonalInfoContext;

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps?.marketDetails?.zipCode && !this.state?.zipCode) {
      this.setState({ zipCode: nextProps.marketDetails.zipCode });
    }
    if (nextProps?.marketDetails) {
      this.setState({ city: nextProps.marketDetails.city, state: nextProps.marketDetails.state });
    }
    const creditApprovalStatus = nextProps.creditReviewSuccessResponse?.serviceResponse?.context?.cartInfo?.creditApprovalStatus;
    const creditFlow = nextProps.creditReviewSuccessResponse?.serviceResponse?.context?.cartInfo?.creditFlow;
    const dueToday = nextProps.cartDetails?.orderDetailsView?.dueTodayAmount;
    let fwaSecurityDeposit = nextProps.creditReviewSuccessResponse?.serviceResponse?.context?.cartInfo?.fwaSecurityDepositAmount;
    fwaSecurityDeposit = fwaSecurityDeposit !== undefined && fwaSecurityDeposit !== null && fwaSecurityDeposit !== '' ? fwaSecurityDeposit : 0;
    const downPaymentAmt = nextProps.creditReviewSuccessResponse?.serviceResponse?.context?.cartInfo?.downPaymentAmount;
    const creditHoldContent = nextProps.creditReviewSuccessResponse?.serviceResponse?.context?.cartInfo?.creditHoldContent;
    const eidQuestionnaire = nextProps.creditReviewSuccessResponse?.serviceResponse?.context?.cartInfo?.eidQuestionnaire;
    if (this.props.creditReviewSuccessResponse !== nextProps.creditReviewSuccessResponse) {
      if (creditApprovalStatus === 'AP' && eidQuestionnaire?.numOfQuestions === 0) {
        if (creditFlow !== 'EdgeIneligible' && downPaymentAmt > 0) {
          goToProcessStep(this.props.currentView.CreditDownPayment, this.props.history);
          nextProps.updateCreditCheckSuccess();
        } else if (fwaSecurityDeposit > 0) {
          goToProcessStep(this.props.currentView.Payment, this.props.history);
        } else if (creditFlow === 'EdgeIneligible') {
          goToProcessStep(this.props.currentView.EdgeIneligible, this.props.history);
        } else if (dueToday > 0) {
          if (this.props.cartDetails && this.props.cartDetails.payments && this.props.cartDetails.payments.length === 0) {
            goToProcessStep(this.props.currentView.Payment, this.props.history);
            nextProps.updateCreditCheckSuccess();
          } else if (
            this.props.cartDetails &&
            this.props.cartDetails.payments &&
            this.props.cartDetails.payments.length > 0 &&
            this.props.cartDetails.payments[0] &&
            this.props.cartDetails.payments[0].paymentType
          ) {
            goToProcessStep(this.props.currentView.OrderReview, this.props.history);
            nextProps.updateCreditCheckSuccess();
          }
          // eslint-disable-next-line
        } else if (dueToday == 0) {
          goToProcessStep(this.props.currentView.OrderReview, this.props.history);
          nextProps.updateCreditCheckSuccess();
        }
      } else if (creditApprovalStatus !== 'AP' && creditHoldContent && eidQuestionnaire?.numOfQuestions === 0) {
        goToProcessStep(this.props.currentView.CreditHold, this.props.history);
        nextProps.updateCreditCheckSuccess();
      }
    }
    if (this.props.eidSubmitResponse !== nextProps.eidSubmitResponse) {
      if (nextProps.creditCheckState?.EidSubmitResponse?.serviceResponse?.context?.cartInfo?.creditHoldContent) {
        goToProcessStep(this.props.currentView.CreditHold, this.props.history);
      }
    }
  }

  render() {
    const type = viewport();
    const { creditBtnText } = this.props;
    const eidQuestionnaire = this.props.creditReviewSuccessResponse?.serviceResponse?.context?.cartInfo?.eidQuestionnaire;
    const creditApprovalStatus = this.props.creditReviewSuccessResponse?.serviceResponse?.context?.cartInfo?.creditApprovalStatus;
    let isEidData = false;
    if (creditApprovalStatus !== 'AP' && eidQuestionnaire?.numOfQuestions > 0) {
      isEidData = true;
    }
    const checkboxContent = this.props.checkbox_text_Desktop ? this.props.checkbox_text_Desktop : '';
    const getEidSubmitCTA = document.getElementById('eidSubmitCTA');
    const enableButton =
      !this.state.showDobError &&
      !this.state.showSsnError &&
      (isVFEligibile() ? this.state.vfSSNCheckValue : isACPEligibile() ? this.state.acpSSNCheckValue : true);
    const fieldvalueChecking = this.state.dob !== '' && this.state.ssn !== '' && this.state.enableCheckbox;

    return (
      <>
        <Row>
          {(eidQuestionnaire && isEidData) ||
          (this.props?.eidQuestionsFromCreditStatus &&
            this.props?.eidQuestionsFromCreditStatus?.numOfQuestions &&
            this.props?.eidQuestionsFromCreditStatus?.numOfQuestions > 0) ? (
            <Col xs={12}>
              <Row>
                <Col xs={12} className={isMobile() || isTablet() ? '' : 'noLeftMargin'}>
                  <Row className={isMobile() || isTablet ? 'noLeftMargin noRightEidMargin' : ''}>
                    <EidQuestionnaire
                      eidQuestionnaire={
                        this.props?.eidQuestionsFromCreditStatus &&
                        this.props?.eidQuestionsFromCreditStatus?.numOfQuestions &&
                        this.props?.eidQuestionsFromCreditStatus?.numOfQuestions > 0
                          ? this.props.eidQuestionsFromCreditStatus
                          : eidQuestionnaire
                      }
                      onSubmit={this.onEidQuestiosAnswerSubmit}
                      getEidSubmitCTA={getEidSubmitCTA}
                    />
                    {this.eidTagging(true)}
                  </Row>
                </Col>
              </Row>
            </Col>
          ) : (
            <Col xs={12}>
              {this.eidTagging(false)}
              <CreditCheckForm
                {...this.props}
                state={this.state}
                onChangeTextBox={this.onChangeTextBox}
                handleZipCode={this.handleZipCode}
                onAddressSelection={this.onAddressSelection}
                addressList={this.props.addressList}
                isEmptyAddress={this.props.isEmptyAddress}
                creditCheckAddressErrorMessage={this.props.creditCheckAddressErrorMessage}
                belowAgeError={this.props.belowAgeStatus}
              />
              <Row>
                <Col
                  xs={12}
                  className={`${type === 'mobile' ? 'marginTop30 checkboxWrapper' : 'marginTop30 checkboxWrappernoLeftPad noRightPad'} `}
                  analyticstrack="5G-specialOffersFlag"
                >
                  <CheckBox
                    className="checkboxAlign"
                    id="consent"
                    component="input"
                    type="checkbox"
                    aria-checked={this.state.enableCheckbox}
                    onChange={(e) => this.checkboxStatus(e)}
                    aria-label={this.props.checkbox_text}
                    selected={this.state.enableCheckbox}
                    tabIndex="0"
                  >
                    {checkboxContent}
                  </CheckBox>
                </Col>
                <Col className={`${type === 'mobile' ? '' : 'noLeftPad noRightPad'} CreditCheckFormWrapper`}>
                  <img className="logoheight" src={NortonSeal} alt="Norton Secured" />
                </Col>
              </Row>
              <Row>
                {!isDesktopResolution() && (
                  <Col xs={12} lg={6} md={6} sm={6} className="margin32 noSideMargin">
                    <Button
                      size="large"
                      width="100%"
                      disabled={!enableButton ? true : !fieldvalueChecking}
                      onClick={() => this.onClickRunCreditCheck()}
                    >
                      {this.state.enableCheckbox ? this.props.button : this.props.ctaDisabledLabel}
                    </Button>
                    <StyledVdsRow mTop="16px" mLeft="5px">
                      <Body size="medium">{creditBtnText}</Body>
                    </StyledVdsRow>
                  </Col>
                )}
              </Row>
            </Col>
          )}
        </Row>
      </>
    );
  }
}
personalInformation.propTypes = {
  contactDetails: PropTypes.object,
  getCartDataFromApi: PropTypes.func,
  getMiniCartAPI: PropTypes.func,
  city: PropTypes.string,
  state: PropTypes.string,
  checkbox_text: PropTypes.string,
  checkbox_text_Desktop: PropTypes.string,
  button: PropTypes.string,
  getZipDetailsFromApi: PropTypes.func,
  marketDetails: PropTypes.object,
  creditReviewSuccess: PropTypes.object,
  currentView: PropTypes.object,
  history: PropTypes.object,
  creditReviewSuccessResponse: PropTypes.object,
  postEidQuestionsAnswers: PropTypes.func,
  getCreditCheckOnClick: PropTypes.func,
  updateCreditCheckSuccess: PropTypes.func,
  creditCheckState: PropTypes.object,
  eidSubmitResponse: PropTypes.bool,
  cartDetails: PropTypes.any,
  eidQuestionsFromCreditStatus: PropTypes.any,
  ShippingInfoDetails: PropTypes.any,
  showZipcodeError: PropTypes.bool,
  retrieveCartAPIStatus: PropTypes.string,
  creditBtnText: PropTypes.string,
  invokeTaggingAPI: PropTypes.func,
  addressList: PropTypes.any,
  isEmptyAddress: PropTypes.bool,
  creditCheckAddressErrorMessage: PropTypes.string,
  fetchAutoFillAddress: PropTypes.func,
  ctaDisabledLabel: PropTypes.string.isRequired,
  belowAgeStatus: PropTypes.string,
};
